import type * as THREE from 'three';

/** Lets UI outside the viewport (project sidebar, export dialogs) reach the live 3D scene. */
export type ViewportBridge = {
  getModel: () => THREE.Object3D | null;
  getOrientation: () => THREE.Quaternion;
  /** Adds a copy of the model next to the original. Returns the new part id. */
  duplicate: () => string | null;
  setVisible: (partId: string, visible: boolean) => void;
};

let bridge: ViewportBridge | null = null;
let version = 0;
const listeners = new Set<() => void>();

export function setViewportBridge(next: ViewportBridge | null) {
  bridge = next;
  notifyViewportBridge();
}

export function notifyViewportBridge() {
  version++;
  listeners.forEach((l) => l());
}

export const getViewportBridge = () => bridge;

/** Display names of the models in the build, published by the project sidebar. */
let partNames: Record<string, string> = {};
export const getPartNames = () => partNames;
export function setPartNames(next: Record<string, string>) {
  partNames = next;
  notifyViewportBridge();
}

/** Currently selected part ('main' or a duplicate id), shared by the sidebar and the viewport. */
let selectedPart: string | null = null;
export const getSelectedPart = () => selectedPart;
export function setSelectedPart(id: string | null) {
  if (selectedPart === id) return;
  selectedPart = id;
  notifyViewportBridge();
}
export const getViewportBridgeVersion = () => version;

export function subscribeViewportBridge(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
